'use client';

import Section from "@/app/features/shared/snap-section/Section";
import { Container, Stack } from "@mui/material";
import TextView from "@/app/__to_be_integrated/_____components/showroom/components/TextView";
import { useShowroom } from "./ShowroomContext";
import ImageCarouselPublic from "@/app/features/shared/image-carusel/ui/public/ImageCarusel.public";
import ImageCarouselEditable from "@/app/features/shared/image-carusel/ui/editable/ImageCarusel.editable";

export default function ShowroomView() {
    const {
        content,
        isEditing,
        setImages,
    } = useShowroom();

    return (
        <Section contentHeight="fit-content" className="showroom-view">
            <Container className="py-16" maxWidth="xl">
                <Stack spacing={4} alignItems='center'>
                    <TextView />
                    {isEditing ? (
                        <ImageCarouselEditable images={content.images} onImagesChanged={setImages} />
                    ) : (
                        <ImageCarouselPublic images={content.images} />
                    )}
                </Stack>
            </Container>
        </Section>
    );
}
